import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-demat-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public module: string;
  public section: string;

  opened = true;
  sidenavMode = 'side';
  title = '';

  constructor() { }

  ngOnInit() {
  }

}
